import "babel-polyfill";
import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import '@/assets/css/base.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vueJsonp from 'vue-jsonp'
import mixinWidth from "../../mixins/index.js"
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(ElementUI)
Vue.use(vueJsonp)
Vue.config.productionTip = false
Vue.mixin(mixinWidth)
Vue.use(Vant);
new Vue({
        render: h => h(App),
        router
    }).$mount('#app')
    // 刷新调用埋点
if (LogCollection) {
    LogCollection.end()
}